export default "__VITE_ASSET__CXUyTmDJ__"